const skills = {
  // HeroSection
  'skills.hero.homeLink': 'ホーム',
  'skills.hero.aboutLink': 'アカデミーについて',
  'skills.hero.currentPage': '習得スキル一覧',
  'skills.hero.title': '習得スキル一覧',
  'skills.hero.titleEn': 'SKILLS',
  'skills.hero.lead': '執事に求められる技能を、5つの領域に整理して体系的に習得します。基礎から管理能力まで、段階的な積み上げで確かな力を育みます。執事・バトラーを育てる日本の執事学校として、これらの技能は執事資格・バトラー資格の取得へとつながります。',
  'skills.hero.imgAlt': '銀食器の手入れを繰り返し練習して技能を磨く受講生の手元',

  // SkillsIntro
  'skills.intro.label': 'FIVE DOMAINS',
  'skills.intro.title': '5つのスキル領域',
  'skills.intro.titleEn': 'Five Skill Domains',
  'skills.intro.description': '執事に求められる技能を、五つの領域に整理しています。サービスの技術、先を読む観察力、品格ある対話、家政を束ねる管理力、そして動じない危機対応力——どの領域も、実践を重ねることで初めて身につくものです。',

  // SkillAreas
  'skills.area.skillsLabel': '習得スキル',
  'skills.area.startLabel': '学び始め:',
  'skills.area.deepenLabel': '深める:',
  'skills.area.startCourse': '習得開始',
  'skills.area.deepenCourse': '深化',
  'skills.area.0.startCourse': 'エッセンシャル',
  'skills.area.0.deepenCourse': 'アドバンス／マスター',
  'skills.area.1.startCourse': 'エッセンシャル',
  'skills.area.1.deepenCourse': 'アドバンス／マスター',
  'skills.area.2.startCourse': 'エッセンシャル',
  'skills.area.2.deepenCourse': 'アドバンス／マスター',
  'skills.area.3.startCourse': 'アドバンス',
  'skills.area.3.deepenCourse': 'マスター',
  'skills.area.4.startCourse': 'マスター',
  'skills.area.4.deepenCourse': 'マスター',
  'skills.area.0.title': 'サービス技能',
  'skills.area.0.titleEn': 'Service Skills',
  'skills.area.0.subtitle': 'テーブル／ティー／ワイン／衣類ケア',
  'skills.area.0.description': '邸宅サービスの中核をなす実務技能です。テーブルセッティング、ティーサービス、ワインの知識と提供、衣類やリネンの管理まで、執事の日常業務に直結する技能を体系的に習得します。衣類の扱いでは、礼装の格式そのものも学びます。19世紀後半から20世紀初頭の英国では、モーニングコートが紳士の日中の装いとして広まり、執事の服装にも取り入れられて「日中の格式ある正装」として定着しました。現代でも、昼間の礼装として最も格式高い「正礼装」とされます。\n\n夜は午後6時頃を境に装いが変わり、最も格式高い夜の正装が黒のテールコートに白いドレスシャツ・白いベスト・白い蝶ネクタイを合わせる燕尾服、その内側にあたる夜の準礼装が、黒またはミッドナイトブルーのジャケットに白いドレスシャツ・黒い蝶ネクタイ・側章が1本入ったトラウザーズを合わせるタキシードです。執事もまた、夜には日中とは異なる装いに着替え、身なりを整えました。',
  'skills.area.0.skill.0': 'フォーマルテーブルの設営と撤収',
  'skills.area.0.skill.1': '紅茶・中国茶の種類別抽出と提供',
  'skills.area.0.skill.2': 'ワインの基礎知識・テイスティング・マリアージュ',
  'skills.area.0.skill.3': '衣類・リネンの素材別ケアと収納管理',
  'skills.area.0.skill.4': 'カトラリー・グラス類の識別と取扱い',
  'skills.area.1.title': '観察力・先回り',
  'skills.area.1.titleEn': 'Observation & Anticipation',
  'skills.area.1.subtitle': '状況把握／先読み／気配り',
  'skills.area.1.description': '雇主やゲストのわずかな仕草や表情から意図を読み取り、求められる前に行動する感覚を養います。これはマニュアルでは伝えきれない、経験と訓練で磨かれる中核的な能力です。',
  'skills.area.1.skill.0': 'ゲストの仕草・表情からの意図察知',
  'skills.area.1.skill.1': '場の空気を読んだタイミング判断',
  'skills.area.1.skill.2': '言葉にされない要望の先回り対応',
  'skills.area.1.skill.3': '季節や時間帯に応じた環境調整',
  'skills.area.2.title': 'コミュニケーション',
  'skills.area.2.titleEn': 'Communication',
  'skills.area.2.subtitle': '言葉遣い／距離感／守秘／品格',
  'skills.area.2.description': '執事の言葉と立ち居振る舞いは、邸宅全体の印象を左右します。敬語の正確さだけでなく、相手との適切な距離感、守秘義務の徹底、書面や電話での応対まで、総合的な対話力を鍛えます。',
  'skills.area.2.skill.0': '状況別の敬語・謙譲語の使い分け',
  'skills.area.2.skill.1': 'ゲストとの適切な距離感の維持',
  'skills.area.2.skill.2': '守秘義務の徹底と情報管理',
  'skills.area.2.skill.3': '書面・メール・電話での格式ある応対',
  'skills.area.2.skill.4': '多言語での基本接遇（英語・中国語）',
  'skills.area.3.title': '管理能力',
  'skills.area.3.titleEn': 'Management',
  'skills.area.3.subtitle': '家政管理／スケジュール／スタッフ統率',
  'skills.area.3.description': '執事は一邸宅の運営責任者です。日々の家政管理、年間行事のスケジュール策定、外部業者との折衝、複数スタッフの統率まで、マネジメント能力が求められます。',
  'skills.area.3.skill.0': '年間行事・日常業務のスケジュール管理',
  'skills.area.3.skill.1': '家計・支出の予算管理と報告',
  'skills.area.3.skill.2': '外部業者（造園・設備・ケータリング）の統括',
  'skills.area.3.skill.3': '複数スタッフのシフト管理と指揮',
  'skills.area.3.skill.4': '美術品・ワインセラー等の資産管理',
  'skills.area.4.title': '危機対応力',
  'skills.area.4.titleEn': 'Crisis Response',
  'skills.area.4.subtitle': '緊急時対応／冷静判断／安全確保',
  'skills.area.4.description': '邸宅で起こりうるあらゆる緊急事態に、冷静かつ的確に対処する力を養います。医療緊急時、火災や地震などの災害、不審者対応まで、執事には高度な危機管理能力が求められます。',
  'skills.area.4.skill.0': '救急・医療緊急時の初動対応',
  'skills.area.4.skill.1': '火災・地震など災害時の避難誘導',
  'skills.area.4.skill.2': '不審者・セキュリティ事案への対処',
  'skills.area.4.skill.3': 'トラブル発生時の雇主・ゲストの心情配慮',
  'skills.area.4.skill.4': '関係機関（警察・消防・医療）との連携手順',

  // CourseSkillsTable
  'skills.table.label': 'BY COURSE',
  'skills.table.title': 'コース別に身につくスキル',
  'skills.table.titleEn': 'Skills by Course',
  'skills.table.description': 'どの領域をどこまで身につけるかは、コースによって異なります。基礎から管理・危機対応まで、段階的に到達目標を引き上げていきます。各コースで学ぶ主なスキルは以下のとおりです。',
  'skills.table.viewDetail': '詳細',
  'skills.table.0.name': 'エッセンシャル',
  'skills.table.0.scope': '基礎の所作とサービス基礎',
  'skills.table.0.details': 'テーブルセッティング、ティーサービス、基本敬語、観察の基礎。執事としての第一歩となる所作とサービス基礎を網羅。',
  'skills.table.1.name': 'アドバンス',
  'skills.table.1.scope': 'エッセンシャルを含む高度サービス・ワイン・イベント・国際マナー',
  'skills.table.1.details': 'エッセンシャルの基礎所作を含んだ上で、ワインサービス、フォーマル晩餐会運営、国際マナー、スタッフ管理基礎を習得。専門性を高め、実務に対応できる力を養う。',
  'skills.table.2.name': 'マスター',
  'skills.table.2.scope': 'エッセンシャル・アドバンスを含む管理・危機対応・VIP対応・リーダーシップ',
  'skills.table.2.details': 'エッセンシャル・アドバンスの内容を含んだ上で、全領域の統合、危機管理、VIP専任サービス、スタッフ統率を習得。執事としての最高水準を目指す。',

  // AchievementGoals
  'skills.goals.label': 'TARGETS',
  'skills.goals.title': '到達目標',
  'skills.goals.titleEn': 'Achievement Targets',
  'skills.goals.description': '5つのスキル領域について、コース別の到達目標を以下に示します。これらは「修了時点で目指す水準」であり、修了を保証する実績値ではありません。',
  'skills.goals.domain.0': 'サービス技能',
  'skills.goals.domain.1': '観察力・先回り',
  'skills.goals.domain.2': 'コミュニケーション',
  'skills.goals.domain.3': '管理能力',
  'skills.goals.domain.4': '危機対応力',
  'skills.goals.course.0': 'エッセンシャル',
  'skills.goals.course.1': 'アドバンス',
  'skills.goals.course.2': 'マスター',
  'skills.goals.footerNote': '※これらの数値は「修了時点で目指す水準」を示す到達目標であり、修了を保証する実績値ではありません。',

  // CertificationSection
  'skills.cert.label': 'CERTIFICATION',
  'skills.cert.title': 'スキルを証明する',
  'skills.cert.titleEn': 'Certifying Your Skills',
  'skills.cert.description': '身につけたスキルは、修了実技試験の合格を通じて協会認定資格として証明されます。合格者には修了証を授与し、執事としての専門性を対外的に示すことができます。日本の執事学校で磨いた技能は、協会独自の認定バトラー資格として形に残せます。',
  'skills.cert.note': '※本資格は本科コース（エッセンシャル／アドバンス／マスター）の修了者を対象とし、法人研修の受講証とは異なります。',
  'skills.cert.viewLink': '修了証・認定資格を見る',
  'skills.cert.badge.title': '協会認定資格',
  'skills.cert.badge.subtitle': '修了実技試験合格者に授与',

  // FAQSection
  'skills.faq.label': 'FAQ',
  'skills.faq.title': 'よくあるご質問',
  'skills.faq.titleEn': 'Frequently Asked Questions',
  'skills.faq.footer': 'その他のご質問は',
  'skills.faq.footerContact': 'お問い合わせ',
  'skills.faq.footerSuffix': 'よりお寄せください',
  'skills.faq.0.question': 'どんなスキルを学べますか？',
  'skills.faq.0.answer': 'サービス技能、観察力・先回り、コミュニケーション、管理能力、危機対応力の5領域を体系的に学びます。',
  'skills.faq.1.question': 'スキルの習得を証明できますか？',
  'skills.faq.1.answer': 'はい。各コース修了時の実技試験に合格すると、協会認定資格を取得できます。',
  'skills.faq.2.question': '未経験でも身につきますか？',
  'skills.faq.2.answer': 'はい。基礎から段階的に積み上げる設計のため、未経験の方も無理なく習得できます。',

  // CTASection
  'skills.cta.label': 'NEXT STEP',
  'skills.cta.title': '学びの成果を確かめる',
  'skills.cta.body': '身につけたスキルを証明する資格制度や、コースの詳細もぜひご確認ください。まずは体験講座で実際の空気を感じてみませんか。',
  'skills.cta.note': '※ご相談はオンラインでも承ります',
  'skills.cta.certificate': '修了証・認定資格を見る',
  'skills.cta.courses': 'コースを見る',
  'skills.cta.seminar': '体験講座で実技を体験する',

  // RelatedPages
  'skills.related.label': 'LEARN MORE',
  'skills.related.title': '関連ページ',
  'skills.related.titleEn': 'Explore Further',
  'skills.related.viewLink': '詳しく見る',
  'skills.related.0.title': '修了証・認定資格について',
  'skills.related.0.desc': '修了で得られる協会認定資格',
  'skills.related.1.title': '実践トレーニング',
  'skills.related.1.desc': '実技とロールプレイング中心の訓練',
  'skills.related.2.title': '使用教材',
  'skills.related.2.desc': '協会監修の教科書全15冊',
  'skills.related.3.title': 'コース一覧・比較',
  'skills.related.3.desc': '3コースの違いを一覧で確認',

  // Last updated
  'skills.lastUpdated': '最終更新: 2026年7月8日',
};

export default skills;
